import React, { useLayoutEffect } from 'react';
import {SetProperLayout } from '../../supplementary_components/isMobile'
import './content.scss';
import { Header} from '../header/header';
import { MainMenu } from '../main_menu/mainMenu';
import { ClassicMenu } from '../main_menu/classicMenu';
import { useClassicMenu } from '../main_menu/menuLayout';
import { PopupManager } from '../popup_manager/popupManager';
import { ItemsListingPage } from './list_view/ItemsLisingPage';
import {LoadingIcon} from '../../supplementary_components/loading_icon';
import {ItemPage} from './item_page/itemPage'
import {TRUCK_LISTING_CONF} from '../../pages/trucks/truckDataDelegate';
import {TRAILER_LISTING_CONF} from '../../pages/trailers/trailerDataDelegate';
import { TrailerManagementPage } from '../../pages/trailers/TrailerManagement';
import {LOAD_LISTING_CONF} from '../../pages/loads/loadDataDelegate';
import {EMPLOYEE_LISTING_CONF} from '../../pages/employees/employeeDataDelegate';

import { NotificationManager } from '../popup_manager/notificationManager';

import { DRIVER_LISTING_CONF } from '../../pages/drivers/driverDataDelegate';
import { NoCompany } from '../content_management/item_page/noCompany';
import { MainBoard } from '../../main_board_components/mainBoard';
import { TEAM_LISTING_CONF } from '../../pages/teams/teamDataDelegate';
import { Reports } from '../../pages/reports/reports';
import { BROKER_LISTING_CONF } from '../../pages/brokers/brokerDataDelegate';
import { FUEL_CARD_LISTING_CONF } from '../../pages/fuelCards/fuelCardDelegate';
import { Statements } from '../../pages/statements/statements';
import { SearchResults } from '../../pages/searchResults/searchResults';
import { Invoices } from '../../pages/invoices/Invoices';
import { InspectionsPage } from '../../pages/inspections/InspectionsPage';
import { TENDER_LISTING_CONF } from '../../pages/tenders/tenderDataDelegate';
import { CompanySettingsPage } from '../../pages/company/companyPageConf';
import { Dashboard } from '../../pages/company/dashboard';
import { MyAccountPage } from '../../pages/myAccount/myAccountPage';
import { can, canSeeLoadRates } from '../../supplementary_components/userDataDelegate';

export const ContentWrapper = ({currentCompany, category, itemIdentifier})=> {
	let ItemToShow = () => {return <LoadingIcon state={true} height={'10rem'} />};
	let conf = null;
	const canSeeRates = canSeeLoadRates();
	
	switch (category) {
	case 'trucks':
		conf = TRUCK_LISTING_CONF;
		break;
	case 'trailers':
		conf = TRAILER_LISTING_CONF;
		break;
	case 'trailer-management':
		conf = 'trailerManagement';
		break;
	case 'loads':
		if(canSeeRates){
			conf = LOAD_LISTING_CONF;
		}else{
			conf = {
				...LOAD_LISTING_CONF,
				columns: LOAD_LISTING_CONF.columns.filter(c => c.columnName !== "payout"),
				filteredResultsSummary: undefined, // or omit
				columnProportions: LOAD_LISTING_CONF.columnProportions.split(/\s+/)
				.filter((_, i) => i !== 3)
				.join(" "),
			};
		}
		
		break;
	case 'tenders':
		conf = TENDER_LISTING_CONF;
		break;
	case 'employees':
		conf = EMPLOYEE_LISTING_CONF;
		break;
	case 'drivers':
		conf = DRIVER_LISTING_CONF;
		break;
	case 'teams':
		conf = TEAM_LISTING_CONF;
		break;
	case 'brokers':
		conf = BROKER_LISTING_CONF;
		break;
	case 'fuel-cards':
		conf = FUEL_CARD_LISTING_CONF;
		break;
	case 'inspections':
		conf = 'inspections';
		break;
	case "dashboard" :
		conf =  "dashboard";
		break;
	case "mainboard" :
		conf =  "mainboard";
		break;
	case "reports" :
		conf =  "reports";
		break;
	case "statements" :
		conf =  "statements";
		break;
	case "invoices" :
		conf =  "invoices";
		break;
	case "search" :
		conf =  "searchResults";
		break;
	case "companySettings" :
		conf =  "companySettings";
		break;
	case "myAccount" :
		conf =  "myAccount";
		break;
	default:
		conf = null;
		break;
	}
	if(currentCompany && currentCompany !== "loading"){
		if (conf !== null){
			ItemToShow = () => {
				if(conf ===  "dashboard"){
					return <Dashboard userCanSeeLoadRates={canSeeRates} />
				}else if(conf ===  "mainboard"){
					return <MainBoard userCanSeeLoadRates={canSeeRates}  />
				}else if(conf ===  "reports"){
					return <Reports itemIdentifier={itemIdentifier} />
				}else if(conf ===  "statements"){
					return <Statements />
				}else if(conf ===  "invoices"){
					return <Invoices />
				}else if(conf === 'inspections'){
					return <InspectionsPage />
				}else if(conf ===  "searchResults"){
					return <SearchResults />
				}else if(conf === "companySettings"){
					return <CompanySettingsPage />
				}else if(conf === "myAccount"){
					return <MyAccountPage />
				}
				if (conf === 'trailerManagement') {
					if (!can('TRAILER_MANAGEMENT', 'FLAG')) {
						return <div className="errorMessage">You do not have access to this page.</div>;
					}
					return <TrailerManagementPage />;
				}
				if (category === 'teams' && !can('TEAMS', 'VIEW')) {
					return <div className="errorMessage">You do not have access to this page.</div>;
				}
				if (category === 'employees') {
					const canViewUsers = can('USERS', 'VIEW');
					const canViewRoles = can('ROLES', 'VIEW');
					const employeeItemOpen = itemIdentifier !== null && itemIdentifier !== '';
					if ((!canViewUsers && !canViewRoles) || (employeeItemOpen && !canViewUsers)) {
						return <div className="errorMessage">You do not have access to this page.</div>;
					}
				}
				if (itemIdentifier !== null && itemIdentifier !== ''){
					if(conf.pageConf){
						return <ItemPage conf={conf} identifier={itemIdentifier} />
					}					
				}
				return <ItemsListingPage ViewStructure={conf} itemIdentifier={itemIdentifier} /> 
			};
		}
	}
	const classicMenu = useClassicMenu();
	const menuPath = category === 'reports' && itemIdentifier ? `reports/${String(itemIdentifier).split('/')[0]}` : category;
	// Adjust when screen resized
	useLayoutEffect(() => {
		function updateSize() {
			SetProperLayout()
		}
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);
	const showShell = currentCompany === undefined || typeof(currentCompany) === 'string' || (currentCompany !== null && typeof(currentCompany) === 'object');
	return <div className="App">
		{showShell ? (
			classicMenu ? (
				<>
					<Header company={currentCompany} />
					<ClassicMenu path={menuPath} />
					<div className="contentWrapper">
						<ItemToShow />
					</div>
				</>
			) : (
				<>
					<Header company={currentCompany} />
					<div className="appShell">
						<MainMenu path={menuPath} />
						<div className="mainColumn">
							<div className="contentWrapper">
								<ItemToShow />
							</div>
						</div>
					</div>
				</>
			)
		) : (
			<>
				<Header company={currentCompany} />
				<div>
					<NoCompany />
				</div>
			</>
		)}
		<PopupManager />
		<NotificationManager />
	</div>

}